/**
 * Words the English catalog capitalizes mid-label that stay capitalized in sentence case: places,
 * peoples and names ("Chicago blues", "New Orleans R&B", "Afro-Cuban jazz", "Te Deum").
 */
const PROPER_WORDS = new Set([
  "Americana",
  "Britpop",
  "Chicago",
  "Coast",
  "Cuban",
  "Deum",
  "Jewish",
  "Orleans",
  "Québ",
  "Texas",
  "York",
]);

/** An acronym or initial as written ("R&B", "UK", "EDM", "DJ", "SKA", "NRG"). */
function isAcronym(word: string): boolean {
  return /^\p{Lu}+$/u.test(word);
}

/**
 * Sentence case for a taxonomy label shown in Portuguese and Spanish ("Blues Rock" → "Blues
 * rock", "Bossa Nova" → "Bossa nova"). The first word stays as written; later words are lowercased
 * unless they are acronyms or proper nouns ("Chicago Blues", "Alternative R&B" keep theirs).
 */
export function sentenceCaseTaxonomyLabel(label: string): string {
  let isFirstWord = true;
  return label.replace(/\p{L}+/gu, (word) => {
    if (isFirstWord) {
      isFirstWord = false;
      return word;
    }
    if (isAcronym(word) || PROPER_WORDS.has(word)) return word;
    return word.toLowerCase();
  });
}
